import VText from '../v-text/component-lib.esm.js';

//
var script = {
  name: 'ToolbarTitle',
  props: {
    ...VText.props
  },
  components: {
    VText
  }
};
export { script as default };